// src/contexts/SidebarContext.jsx
import { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext({ collapsed: false, setCollapsed: () => {} });

export function SidebarProvider({ children }) {
  // Default: collapsed on small screens
  const [collapsed, setCollapsed] = useState(() => {
    if (typeof window !== 'undefined') return window.innerWidth < 1024;
    return false;
  });

  useEffect(() => {
    const check = () => {
      if (window.innerWidth < 1024) setCollapsed(true);
    };
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return (
    <SidebarContext.Provider value={{ collapsed, setCollapsed }}>
      {children}
    </SidebarContext.Provider>
  );
}

export const useSidebar = () => useContext(SidebarContext);
